import { Route, Routes } from "react-router-dom";

import Banner from './Banner';
import LeftNav from './LeftNav';
import Home from './pages/Home';
import Report from './pages/Report';
import PageNotFound from './PageNotFound';

import Box from '@mui/material/Box';

const PageLayout = () => {
  const isAuthenticated = Boolean(sessionStorage.getItem("isAuthenticated"));
  if (isAuthenticated) {
    return (
      <Box>
        <Banner />
        <Box sx={{ display: "flex" }} >
          <LeftNav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="reports/:id" element={<Report />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Box>
      </Box>
    )
  } 
}

export default PageLayout